import React from "react"
import {FieldGlistGroupProps} from "../../../../render/glist/glist-group";


export default function FieldUser_GlistGroupModern(props:FieldGlistGroupProps) {

    const value = props.data.value

    const groupName = _.get(props.field._getOption(value),'label', props.field.noValueOptionLabel)

    const user = gd.session.users.get(value)
    let groupColor = user ? user.initials[0].toLowerCase() : ''
    if (groupColor.match(/[^a-z0-9]/)) groupColor = 'a'

    const groupNameClasses = Classes("ui5-group-by-text-2", {
        ['gd-{0}'.f(groupColor)]: !!groupColor,
        ['text-color-white']    : !groupColor,
    })

    return <div className={groupNameClasses}>{groupName}</div>


}
